import React from 'react';
import { NikoTemplateMissingProductNoteModalTemplate } from 'themes/application/niko-patient/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoTemplateMissingProductNoteModalStore } from 'application/niko-patient/stores';

@setCurrentView((rootStore, componentProps) => new NikoTemplateMissingProductNoteModalStore(rootStore, componentProps), 'nikoTemplateMissingProductNoteModalStore')
@observer
class NikoTemplateMissingProductNoteModal extends React.Component {
    render() {
        return <NikoTemplateMissingProductNoteModalTemplate {...this.props} />
    }
}

export default NikoTemplateMissingProductNoteModal;
